import { LocaleResources } from 'locales';
import React from 'react';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { Product } from 'src/models/product/schema';
import styles from '../index.module.scss';
import { closeZendesk } from 'src/utils/zendesk';
import { AbuseNotice } from '../AbuseNotice';
import { CartAddButton } from './CartAddButton';
import { Information } from './Information';
import { Description } from './Description';

type Props = {
  localeResources: LocaleResources;
  product: Product;
  quantity: number;
  isProductList: boolean;
  productSaleInfoHref: string;
  closeModal: () => void;
  closeZendesk: () => void;
  openZendesk: () => void;
  onAddToCart: (product: Product, quantity: number, source: string) => void;
  setIsVisible: (isVisible: boolean) => void;
};

export const Presenter: React.FC<Props> = ({
  localeResources,
  product,
  quantity,
  isProductList,
  productSaleInfoHref,
  closeModal,
  openZendesk,
  onAddToCart,
  setIsVisible,
}) => (
  <CommonModal
    title={localeResources.products.chemicals.confirm}
    closeModal={closeModal}
    fixedElement={
      <CartAddButton
        product={product}
        quantity={quantity}
        localeResources={localeResources}
        closeZendesk={closeZendesk}
        onAddToCart={onAddToCart}
        setIsVisible={setIsVisible}
      />
    }
  >
    <div className={styles.container}>
      <Information product={product} localeResources={localeResources} />
      {product?.medicalCanAbuse && <AbuseNotice />}
      <Description
        isProductList={isProductList}
        product={product}
        localeResources={localeResources}
        productSaleHref={productSaleInfoHref}
        openZendesk={openZendesk}
      />
    </div>
  </CommonModal>
);
